export const extractErrorMessages = (errorResponse) => {
  if (!errorResponse?.data?.message) {
    return [];
  }

  const errorMessages = [];

  for (const key in errorResponse.data.message) {
    if (Array.isArray(errorResponse.data.message[key])) {
      errorMessages.push(...errorResponse.data.message[key]);
    }
  }

  return errorMessages;
};

export const extractFirstErrorMessage = (errorResponse) => {
  return extractErrorMessages(errorResponse)[0];
};

